<template>
    <div class="container-fluid">
        <br>
        <p class="text-header">LIST ACCOUNTS</p>
       
        <div class="account-details">
            <div class="col-sm-12 table table-responsive">
                <div class="contract-header">
                    <div> <span class="badge badge-primary">{{ modelCount }}</span> ACCOUNTS </div>
                    <div> </div>
                </div>
    
                <div class="table table-responsive table-sm">
                    <div class="mb-3">
                    <input 
                        type="text" 
                        class="form-control"
                        placeholder="Search..."
                        v-model="search"
                    />
                    </div>

                    <v-data-table :headers="header" :items="desserts" dense :search="search" class="table-striped table-bordered table-responsive">

                    </v-data-table>
                </div>
            </div>
        </div>
       

        <p>&nbsp;</p>
        <page-loader :is-loading="isLoading"></page-loader>
    </div>
    </template>
    
      
    <script>
    //import swal from 'sweetalert2';
    import PageLoader from '../components/PageLoader.vue'
    import * as XLSX from "xlsx";
    
    export default {
    
        name: "AllUsersPage",
        components: {
            //quillEditor,
            PageLoader,
        },
    
        data() {
            return {
    
                isLoading: false,
                isRightImage: false,
                isLeftImage: false,
                isBackImage: false,
                is_transaction_fee: true,
                is_transaction_fee_hidden: false,
                user_id: '',
                firstname: '',
                lastname: '',
                bank_name: '',
                account_name: '',
                account_number: '',
    
                loading: false,
                loading1: false,
                loading2: false,
                loading3: false,
                role_type: '',
                contract_title: '',
                transaction_type: '',
                delivery_type: '',
                delivery_location: '',
                delivery_time: '',
                contract_amount: '',
                transaction_fee: '',
                whois_paying: '',
                contract_rebate: '',
                product_description: '',
                accept_terms: '',
    
                products: [],
                subcategorys: [],
                selectedFile: '',
                selectedFile1: '',
                selectedFile2: '',
                selectedFile3: '',
                addProduct: false,
                viewProduct: true,
                editorOptions: {
                    placeholder: 'Write something...',
                },
    
                isVariations: false,
                productid: '',
                variations: '',
                vprice: '',
                is_fees_status: false,
                is_submit: false,
                is_submit1: false,
                is_submit2: false,
                is_submit3: false,
                img_url: process.env.VUE_APP_IMAGE_URL,
                search: "",
                header: [
                    {
                        value: 'name',
                        text: 'Name'
                    },             
                    {
                        value: 'bank',
                        text: 'Bank'
                    },
                    {
                        value: 'account',
                        text: 'Account'
                    },
                    {
                        value: 'phone',
                        text: 'Phone'
                    },
                   
                ],
    
                desserts: [],
                user_role: '',
                product_id: '',
                userid: '',
                modelCount: '',
            
                modelData: [],
                isPeriod: false,
                delivery_period: '',
                payment_status: '',
                is_escrow_charge: false,
                error: '',
                error1: '',
                duration_twelve: false,
                duration_twelve1: true,
                label1: '',
                isContractLink: false,
                contractLink: '',
                service_charge_fee: '',

                createFarmerModel: false,
                selectedUser: {
                    picture: "",
                    username: "",
                    email: "",
                    phone: "",
                    age: "",
                    country: "",
                    location: "",
                    state: "",
                },

                firstName: "",
                lastName: "",
                middleName: "",
                emailAddress: "",
                mobileNumber: "",
                dob: "",
                address: "",
                city: "",
                username: "",
                
                 // BVN modal
                bvnModal: false,
                bvn: "",

                // NIN modal
                ninModal: false,
                nin: "",
                customerId: '',

                // wallet modal
                walletModal: false,
                full_name: '',
                customerId: '',
                phone_number: '',

                isBulk: false,
                bulkFile: null,

            };
        },
    
        beforeMount() {
    
        },
    
        async mounted() {
    
            this.username = localStorage.getItem("username");
            this.user_id = localStorage.getItem("userid");
    
            await this.fetchAllWallets()
        },
    
        created() {
    
        },
    
        computed: {

            indexSn() {
                return this.desserts.map((d, index) => ({
                    ...d,
                    sn: index + 1
                }))
            },
    
        },
    
        methods: {
            validateNumber() {
            const value = this.delivery_period;
            if (value < 0) {
              this.error = 'Value must be non-negative';
              this.delivery_period = ''
              return
            } else if (!Number.isInteger(Number(value))) {
              this.error = 'Value must be an integer';
              this.delivery_period = ''
              return
            } else {
              this.error = '';
            }
          },
    
            formatToCurrency(value) {
              return value.toLocaleString('en-NG', { minimumFractionDigits: 2 })
            },
    
           
            copied(){
                this.isContractLink = false
            },
    
            copyToClipboard(link) {
               // var copyText = document.getElementById("myInput");
                navigator.clipboard.writeText(link).then(function() {
                    alert("Contract link copied to clipboard!");
                }).catch(function(err) {
                    console.error('Failed to copy: ', err);
                });
            },
    
            copyToClipboard1(link) {
               // var copyText = document.getElementById("myInput");
                navigator.clipboard.writeText(link).then(function() {
                    alert("Contract link copied to clipboard!");
                }).catch(function(err) {
                    console.error('Failed to copy: ', err);
                });
            },
            async submitFarmer() {
                try {
                const response = await this.$http.post("/farmers/create-customer", {
                    firstName: this.firstName,
                    lastName: this.lastName,
                    middleName: this.middleName,
                    emailAddress: this.emailAddress,
                    mobileNumber: this.mobileNumber,
                    dob: this.dob,
                    address: this.address,
                    city: this.city,
                    username: this.username,
                });

                if (res.status === "00") {
                const farmer = res.data[0]; // first created farmer
                    alert(
                        `Farmer created successfully!  
                        ID: ${farmer.customerId}  
                        Name: ${farmer.firstName} ${farmer.lastName}`
                    );
                    // this.closeApprovalModal();
                }

                // ERROR FROM BACKEND
                else {
                alert(res.message || "Failed to create farmer");
                }

                //this.closeApprovalModal();

                } catch (error) {
                console.error(error);
                alert("Failed to create farmer");
                }
            },

            handleBulkFile(event) {
            const file = event.target.files[0];
            if (!file) return;

            const fileName = file.name.toLowerCase();

            // Check by extension
            if (!fileName.endsWith(".xlsx") && !fileName.endsWith(".xls")) {
                this.$toast.error("Invalid file type. Please upload an Excel file (.xlsx or .xls)");
                return;
            }

            const reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });

                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                // Convert Excel sheet to JSON
                let json = XLSX.utils.sheet_to_json(sheet, { defval: "" });

                // Append username to every row
                json = json.map(row => ({
                ...row,
                username: this.username
                }));

                this.bulkFile = json; // Now bulkFile is an array of customer objects
                this.$toast.success("File loaded successfully!");
            };

            reader.readAsArrayBuffer(file);
            },

            async uploadBulkFarmers() {
            if (!this.bulkFile || this.bulkFile.length === 0) {
                this.$toast.error("Please select an Excel file and load it first");
                return;
            }

            try {
                // Send the parsed JSON array directly
                const res = await this.$http.post("/farmers/create-bulk-customers", this.bulkFile);

                if (res.data.status === "00") {
                this.$toast.success("Farmers uploaded successfully!");
                // Optionally, clear the file after upload
                this.bulkFile = [];
                } else if (res.data.errors && res.data.errors.length > 0) {
                // Show the first error message
                this.$toast.error(res.data.errors[0]?.message || res.data.message);
                } else {
                this.$toast.error(res.data.message || "Bulk upload failed");
                }
            } catch (err) {
                console.error(err);
                this.$toast.error("Bulk upload failed due to network or server error");
            }
            },

            // BVN modal controls
            openBVNModal(customerId) {
                this.customerId = customerId
                this.bvnModal = true;
            },
            closeBVNModal() {
                this.bvnModal = false;
                this.bvn = ''
                this.customerId = ''
            },

            // NIN modal controls
            openNINModal() {
                this.ninModal = true;
            },
            closeNINModal() {
                this.ninModal = false;
            },
            // BVN verification function
            async verifyBVN() {
            try {

                if (this.bvn.length !== 11) {
                alert("BVN must be 11 digits");
                return;
                }

                const response = await this.$http.post("/farmers/verify-customer-bvn", {
                bvn: this.bvn,
                customerId: this.customerId
                });

                const res = response.data;

                if (res.status === "00") {
                const verifiedData = res.data?.[0];     // first item
                const errorData = res.errors?.[0];       // first error

               // Check actual BVN error
                if (res.errors && res.errors.length > 0 && res.errors[0] !== null) {
                    alert(res.errors[0].message || "BVN verification error");
                } else {
                    alert("BVN Verified Successfully!");
                }
                } else {
                // Backend returned E99 or other error
                alert(res.message || "Verification failed.");
                }

            } catch (error) {
                console.error("BVN error:", error);
                this.$toast.error("Network or server error");
            }
            },

            // NIN verification function
            async verifyNIN() {
                try {
                const response = await axios.post("/api/verify/nin", { nin: this.nin });
                alert("NIN Verified Successfully!");
                this.closeNINModal();
                } catch (e) {
                alert("NIN Verification Failed");
                }
            },

            async fetchAllWallets() {
                try {
                    this.isLoading = true
                    this.desserts = []
                    const encodedUsername = encodeURIComponent(this.username);
                    const response = await this.$http.get(`/wallet/fetch-wallets/${encodedUsername}`, {

                    })
                    this.isLoading = false
                    
                    //let photo_url = '';
                    this.modelData = response.data.data
                    this.modelCount = this.modelData.length
                    this.modelData.forEach(el => {
                        this.desserts.push({
                            name: el.name,
                            bank: el.bankName,
                            account: el.accountNumber,
                            phone: el.mobilePhone,
                        })
                    });
    
                } catch (err) {
                    alert(err.response ? err.response.data.message : err.message)
                    this.isLoading = false
                    //this.$router.push('/home')
                    console.log(err);
                }
            },

            openWalletModal(customerId, name, phone){
                this.customerId = customerId
                this.full_name = name
                this.phone_number = phone
                this.walletModal = true;
            },

            closeWalletModal() {
                this.walletModal = false;
            },

            async createMyWallet() {
            try {
                const response = await this.$http.post("/wallet/create-wallet", {
                customerId: this.customerId,
                name: this.full_name,
                phoneNumber: this.phone_number
                });

                // HTTP 2xx → success
                const res = response.data;
                this.$toast.success(res.message || "Wallet created successfully");

            } catch (error) {
                // Axios error object contains the server response
                if (error.response && error.response.data) {
                const res = error.response.data;

                const errorMessage = res.error?.message || res.message || "Wallet creation failed";
                this.$toast.error(errorMessage);

                console.error("Backend error:", res);
                return;
                }

                // Network error or other unexpected error
                console.error("Network or server error:", error);
                this.$toast.error("Network or server error");
            }
            },

            openApprovalModal(user) {
            console.log(user)
            this.createFarmerModel = true;
            this.selectedUser = {
                picture: user.photo_url || "",
                username: user.username || "",
                email: user.email || "",
                phone: user.phone || "",
                age: user.age || "",
                country: user.country || "",
                location: user.location || "",
                state: user.state || "",
            };
           
            },
            closeApprovalModal() {
            this.createFarmerModel = false;
            },
            approveUser(user) {
            // Handle approval logic here
              console.log("User approved:", user);

            },
    
        }
    
    }
    </script>
      
    <style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap');
    /* Dark backdrop */
/* Backdrop */
    .modal-backdrop-custom {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    }

    /* Modal wrapper (center container) */
    .modal-wrapper {
    width: 100%;
    max-width: 600px;
    }

    /* Header */
    .subs-content {
    padding: 0.5rem;
    background-color: #D33E74; /* Bootstrap success green */
    }
    .btn-success{
        background-color: #D33E74; 
        border: 0px;
    }
    .btn-xs{
        padding: 0.2rem;
        border: 0px;
        font-family: Poppins;
        font-size: 12px;
        font-weight: 500;
    }
    .modal-footer{
        padding: 0.5rem;
    }
    /* User info */
    .user-info p {
    font-size: 1rem;
    color: #222;
    border-bottom: 1px solid #f1f1f1;
    padding-bottom: 8px;
    }
    .user-info p:last-child {
    border-bottom: none;
    }

    .user-info strong {
  display: block;
  font-size: 0.9rem;
  margin-bottom: 4px;
  color: #6c757d;
}
.user-info div {
  font-size: 1rem;
  color: #212529;
  font-weight: 500;
}

    .error {
        color: #fff;
      }
      .error1 {
        color: #fff;
      }
    .quill-container {
        height: 200px;
        /* Set the desired height here */
    }
    .copy-refid{
        cursor: pointer;
        font-size: 16px;
    }
    .copy-refid1{
        cursor: pointer;
        font-size: 15px;
        font-weight: 600;
    }
    .a-text {
        font-size: 12px;
        font-family: Poppins;
    }
    .a-text1 {
        font-size: 14px;
        font-family: Poppins;
    }
    .process-payment{
        cursor:pointer;
    
    }
    label {
        font-size: 12px;
        font-family: Poppins;
        font-weight: normal;
    }
    
    .inputs {
        margin-top: 20px;
        border-radius: 3px;
        font-size: 12px;
    }
    
    .price-fee {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    
        div {
            margin: 4px;
            width: 100%;
    
        }
    }
    
    .adjust-fee-input {
        // width: 100px;
        text-align: center;
    }
    
    .whopays-fee-input {
        //width: 100% !important;
    }
    
    .shop-detail {
        font-size: 12px;
        font-family: Poppins;
    }
    
    .btn-danger {
        text-transform: uppercase;
        font-size: 13px;
        font-family: Poppins;
        background: #D33E74;
        border: 0px;
        height: 45px;
    }
    
    .text-header {
        padding: 0.5rem;
        font-size: 14px;
        font-weight: bold;
        font-family: Poppins;
        background: #ccc;
    }
    
    .contract-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: #D33E74;
        color: #fff;
        border-radius: 4px;
        padding: 0.8rem;
        font-size: 14px;
        font-weight: 700;
        font-family: Poppins;
        margin-bottom: 5px;
    }
    
    .welcome {
        font-family: Poppins;
        font-size: 20px;
        font-weight: 700;
        margin-top: 15px;
        color: #170e0fac;
    }
    
    .account-details {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        //padding: 0.9rem;
        background: #fff;
        width: 98%;
    }
    
    .account-balance {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #780712;
        color: #fff;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-family: Poppins;
        padding: 0.4rem;
        padding-left: 2rem;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .wallet-detail {
        padding-top: 1rem;
        line-height: 1.4px;
        font-size: 15px;
    
        h4 {
            font-weight: 650;
        }
    
        .acct-d {
            line-height: 0.8;
            cursor: pointer;
            text-decoration: underline;
        }
    }
    
    .wallet-icon {
        font-size: 60px
    }
    
    .fund-account {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #076378;
        color: #fff;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-family: Poppins;
        padding: 0.4rem;
        padding-left: 2rem;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .inputs-field {
        font-size: 14px;
        font-family: Poppins;
        height: 45px;
    }
    
    .content-center {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border: solid 1px #170e0fac;
        border-radius: 4px;
        padding: 0.5rem;
        margin: 4px;
    }
    
    .box1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .image-input {
        margin-top: 10px;
    }
    
    .box-icon {
        padding-left: 0.4rem;
        font-size: 35px;
        color: #637807;
    }
    
    .box-details {
        font-size: 14px;
        color: #170e0fac;
    }
    
    .box1:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box2:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box3 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box3:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box4 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box4:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box5 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box5:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box6 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box6:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .img {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
    
    .box-details {
        padding: 0.4rem;
        line-height: 1.4px;
    
        .title {
            font-family: Poppins;
            font-weight: 550;
            font-size: 10px;
            text-transform: capitalize;
            color: #ff4d63;
        }
    
        .description {
            font-family: Poppins;
            font-size: 12px;
        }
    }
    
    .continue {
        display: flex;
        flex-direction: row;
        justify-content: right;
        padding-right: 0.4rem;
        font-size: 30px;
        color: rgb(237, 138, 108);
        margin-right: 10px;
        margin-top: -10px;
        margin-bottom: 10px;
    }
    
    .modal-mask {
        position: fixed;
        //z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;
    
        &>div {
            width: 90%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
            ;
            backdrop-filter: blur(13px);
            border-radius: 10px;
            box-sizing: border-box;
            font-family: Poppins;
        }
    
        h3 {
            margin-top: 10px;
            font-size: 18px;
            color: #000;
            font-weight: bold;
            font-family: Poppins;
        }
    }
    
    .account-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    .account-content-h {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50px;
    
        padding-top: 1.3rem;
        text-transform: uppercase;
        text-align: center;
        //text-decoration: underline;
    }
    
    .add-fund {
        font-size: 12px;
        text-decoration: none !important;
        text-transform: capitalize;
    }
    
    .account-content-d {
        padding-top: 1.3rem;
        font-size: 14px;
        margin-bottom: 10px;
    }
    
    .btn-secondary {
        text-transform: uppercase;
    }
    
    .modal-close {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    }
    
    .modal-close-mobile {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    
        display: none;
    }
    
    a {
        text-decoration: none;
    }
    
    .shop-name {
        //font-weight: 550;
        color: #000;
        font-family: Poppins;
    }
    
    @media screen and (max-width: 768px) {
        .copy-refid1{
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
        }
        .inputs-field {
            font-size: 12px;
            font-family: Poppins;
            font-weight: normal;
            height: 45px;
        }
        .contract-header {
    
            font-size: 12px !important;
    
        }
    
        .counter {
            font-size: 13px;
            font-weight: 500 !important;
        }
    
        .welcome {
            font-family: Poppins;
            font-size: 16px;
            font-weight: 700;
            text-align: left;
            color: #170e0fac;
        }
    
        .content-center {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 0.9rem;
        }
    
        .image-input {
            margin-top: 20px;
        }
    
        .price-fee {
            display: flex;
            flex-direction: column;
    
            div {
                width: 100%;
            }
        }
        .margin-mobile{
            margin-top: 90px;;
        }
    
        .adjust-fee-input {
            width: 100%;
        }
    
        .account-details {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            width: 100%;
        }
    
        .account-balance {
            margin-bottom: 10px;
        }
    
        .box-details {
            padding: 0.4rem;
            line-height: 1.4px;
    
            .title {
                font-family: Poppins;
                font-weight: 550;
                font-size: 8px;
                text-transform: capitalize;
                color: #ff4d63;
            }
    
            .description {
                font-family: Poppins;
                font-size: 12px;
            }
        }
    
        .inputs {
            font-size: 12px;
        }
    
        .box1 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box2 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box3 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box4 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box5 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .continue {
            display: flex;
            flex-direction: row;
            justify-content: right;
            padding-right: 0.4rem;
            font-size: 30px;
            margin-top: -10px;
            color: rgb(237, 138, 108);
        }
    
        .modal-close-mobile {
            display: block;
        }
    
        .modal-close {
            display: none;
        }
    
        .account-content {
            margin: 0px;
            margin-right: 0px;
        }
    
    }
    </style>
    